/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentDeliveryOption
 */
export interface AppointmentDeliveryOption {
    /**
     * 
     * @type {string}
     * @memberof AppointmentDeliveryOption
     */
    type?: AppointmentDeliveryOptionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDeliveryOption
     */
    telemedicine_method?: AppointmentDeliveryOptionTelemedicineMethodEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentDeliveryOption
     */
    only_subscribers?: boolean;
}


/**
 * @export
 */
export const AppointmentDeliveryOptionTypeEnum = {
    Clinic: 'Clinic',
    Video: 'Video',
    Home: 'Home',
    Lab: 'Lab'
} as const;
export type AppointmentDeliveryOptionTypeEnum = typeof AppointmentDeliveryOptionTypeEnum[keyof typeof AppointmentDeliveryOptionTypeEnum];

/**
 * @export
 */
export const AppointmentDeliveryOptionTelemedicineMethodEnum = {
    Video: 'Video',
    Phone: 'Phone'
} as const;
export type AppointmentDeliveryOptionTelemedicineMethodEnum = typeof AppointmentDeliveryOptionTelemedicineMethodEnum[keyof typeof AppointmentDeliveryOptionTelemedicineMethodEnum];


/**
 * Check if a given object implements the AppointmentDeliveryOption interface.
 */
export function instanceOfAppointmentDeliveryOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppointmentDeliveryOptionFromJSON(json: any): AppointmentDeliveryOption {
    return AppointmentDeliveryOptionFromJSONTyped(json, false);
}

export function AppointmentDeliveryOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentDeliveryOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'telemedicine_method': !exists(json, 'telemedicine_method') ? undefined : json['telemedicine_method'],
        'only_subscribers': !exists(json, 'only_subscribers') ? undefined : json['only_subscribers'],
    };
}

export function AppointmentDeliveryOptionToJSON(value?: AppointmentDeliveryOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'telemedicine_method': value.telemedicine_method,
        'only_subscribers': value.only_subscribers,
    };
}

